var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NavMessage } from "../../messages/NavMessage";
import { ParcelLayer } from "./ParcelLayer";
import { AsyncRefresh, Observable } from "../../../lib/misc/decorators";
import { StyleManager } from "../../../lib/layers/selectable/styling";
import { Maybe } from "../../../lib/misc/option";
let InspectionsLayer = class InspectionsLayer extends ParcelLayer {
    constructor(opts) {
        super(opts);
        this.selected = [];
        this.style_manager = new StyleManager(opts.identifier, () => this.selected, () => this.hovered);
    }
    get ids() { return this.selected; }
    changed() {
        this.raw.changed();
    }
    async add_features_by_geometry(geometry) {
        this.selected = [];
        this.source.forEachFeature((feature) => {
            const maybe_geom = Maybe(feature.getGeometry());
            maybe_geom.map(geom => {
                if (geometry.intersectsExtent(geom.getExtent()))
                    this.selected.push(feature.get(this.identifier));
            });
        });
        this.changed();
    }
    clicked_existing_feature(f, alt = false) {
        this.clicked = f.get(this.identifier);
        this.selected = [this.clicked];
        if (alt) {
            new NavMessage({
                command: 'NAVIGATE',
                strap: this.clicked,
                clicked: true,
                alt: true
            }).send();
        }
    }
    async clicked_nonexistent_feature(coord, alt = false) {
        if (!alt) {
            this.clicked = '';
            this.selected = [];
            new NavMessage({
                command: 'NAVIGATE',
                strap: '',
                clicked: true,
                alt: false
            }).send();
            return;
        }
        const maybe_feature = await this.data.get_feature_at_point(coord);
        maybe_feature.map(f => {
            new NavMessage({
                command: 'NAVIGATE',
                strap: f.get(this.identifier) || '',
                clicked: true,
                alt: true
            }).send();
        });
    }
    async add_feature_at_point(coordinate, alt = false) {
        let maybe_feature = this.data.get_feature_at_point_fast(coordinate);
        return await maybe_feature.mapOrElse(async () => await this.clicked_nonexistent_feature(coordinate, alt), async (f) => await this.clicked_existing_feature(f, alt));
    }
    async select_feature(id) {
        if (!id)
            return;
        let maybe_f = await this.get_feature_by_id(id);
        await maybe_f.map(async (f) => {
            await this.clicked_existing_feature(f);
        }).unwrapOr(Promise.resolve());
    }
    async add_features_by_ids(ids, focused) {
        await super.add_features_by_ids(ids, focused);
        this.source.clear();
        this.source.addFeatures(this.data.features);
    }
};
__decorate([
    AsyncRefresh
], InspectionsLayer.prototype, "add_features_by_geometry", null);
__decorate([
    AsyncRefresh
], InspectionsLayer.prototype, "add_feature_at_point", null);
__decorate([
    AsyncRefresh
], InspectionsLayer.prototype, "select_feature", null);
__decorate([
    AsyncRefresh
], InspectionsLayer.prototype, "add_features_by_ids", null);
InspectionsLayer = __decorate([
    Observable
], InspectionsLayer);
export { InspectionsLayer };
